import { useRef, useEffect } from 'react';
import { Plot } from '@int/geotoolkit/plot/Plot';
import { WellBoreNode } from '@int/geotoolkit/schematics/scene/WellBoreNode';
import { WellBoreData } from '@int/geotoolkit/schematics/data/WellBoreData';
import { CompositeSchematicsWidget } from '@int/geotoolkit/schematics/widgets/CompositeSchematicsWidget';
import wellBoreNodeLatestData from './helpers/wellBoreNodeLatestData.json';
import { FillStyle } from '@int/geotoolkit/attributes/FillStyle';
// import { WellBoreWithLabels } from '@int/geotoolkit/schematics/scene/WellBoreWithLabels';
// import { from } from '@int/geotoolkit/selection/from';
import { ViewMode } from '@int/geotoolkit/schematics/scene/WellBoreNode';
import { Group } from '@int/geotoolkit/scene/Group';
import { Rectangle } from '@int/geotoolkit/scene/shapes/Rectangle';
import { CssLayout } from '@int/geotoolkit/layout/CssLayout';
import { Layer } from '@int/geotoolkit/scene/Layer';
import { Events as SelectionEvents } from '@int/geotoolkit/controls/tools/Selection';
import { ComponentNode } from '@int/geotoolkit/schematics/scene/ComponentNode';
// import { DataTable } from '@int/geotoolkit/data/DataTable';
// import { DataTableAdapter } from '@int/geotoolkit/widgets/data/DataTableAdapter';
// import { TableView } from '@int/geotoolkit/widgets/TableView';
// import { Dimension } from '@int/geotoolkit/util/Dimension';
import { LineStyle } from '@int/geotoolkit/attributes/LineStyle';
// import { ComponentUtils } from '@int/geotoolkit/schematics/utils/ComponentUtils';
import { Rect } from '@int/geotoolkit/util/Rect';
import { ComponentNodeFactoryRegistry } from '@int/geotoolkit/schematics/factory/ComponentNodeFactoryRegistry';
import { WellLogWidget } from '@int/geotoolkit/welllog/widgets/WellLogWidget';
import { LogAbstractVisual } from '@int/geotoolkit/welllog/LogAbstractVisual';
import { TrackType } from '@int/geotoolkit/welllog/TrackType';
// import { HeaderType } from '@int/geotoolkit/welllog/header/LogAxisVisualHeader';
import { BasePage } from 'altus-ui-components';
// import { required } from 'utils/validation.util';

import {
  // Table,
  // TableRow,
  // TableBody,
  // TableCell,
  // Typography,
  // Fab,
  // IconButton,
  Button,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
// import makeStyles from '@material-ui/styles/makeStyles';

// import { CssStyle } from '@int/geotoolkit/css/CssStyle';
import './wellBoreStyleLatest.css';
// import SimpleTable from './table';
import SchematicDrawer from './SchematicDrawer';
import { useState } from 'react';
import { Field, Formik, Form } from 'formik';
import SelectTextFieldFormik from 'app/components/form/formik/SelectTextFieldFormik';
// import TextAreaField from 'app/components/form/TextAreaField';
// import TextField from 'app/components/form/TextField';
import { fromJS } from 'immutable';
import Agent from 'infrastructure/agent';
import withStyles from '@material-ui/styles/withStyles';
// import TextAreaFieldFormik from 'app/components/form/formik/TextAreaFieldFormik';
import TextFieldFormik from 'app/components/form/formik/TextFieldFormik';

let leftRectangle, rightRectangle;

const items = [
  'anchor catcher',
  'bent sub',
  'blast joint',
  'blind pipe',
  'bridge plug',
  'casing brush',
  'casing cutter closed',
  'casing cutter open',
  'casing',
  'cement plug',
  'cement',
  'chemical injection mandrel',
  'choke',
  'circulating sleeve',
  'circulating string',
  'corod',
  'crossover enlarging',
  'crossover reducing',
  'crossover',
  'cuttings',
  'default',
  'downhole choke',
  'drill collar',
  'drill pipe',
  'dual tubing hanger',
  'electric submersible pump',
  'expandable sand screen',
  'expansion joint.2',
  'expansion joint',
  'external packer',
  'float sub',
  'flow coupling',
  'gas anchor',
  'gas lift dummy',
  'gas lift mandrel',
  'gravel pack crossover',
  'gravel pack extension',
  'gravel pack screen',
  'heavy weight drill pipe',
  'hole opener',
  'holefill',
  'hydraulic packer',
  'jar',
  'jet pump',
  'landing collar',
  'landing nipple',
  'liner hanger',
  'liner',
  'locator sub',
  'mandrel',
  'mud motor',
  'mule shoe',
  'nipple',
  'nogo nipple',
  'on-off tool',
  'open hole',
  'packer dual',
  'packer.blue',
  'packer',
  'pdc drill bit',
  'perforated liner',
  'perforated tubing.2',
  'perforated tubing',
  'perforating guns',
  'perforation',
  'plug',
  'polished nipple',
  'polished rod',
  'pony rod',
  'port collar',
  'production packer',
  'profile nipple',
  'progressive cavity pump',
  'pump barrel',
  'pump',
  'pup joint',
  'reamer',
  'reentry guide',
  'rod pump.2',
  'rod pump',
  'rod.green',
  'safety valve closed',
  'safety valve open',
  'sand control screen',
  'scssv 1 sub',
  'scssvsub',
  'seal assembly.2',
  'seal assembly',
  'seal bore receptacle',
  'seating nipple',
  'shear tool',
  'side pocket mandrel.2',
  'side pocket mandrel',
  'sinker bar',
  'sliding sleeve.2',
  'sliding sleeve',
  'slotted liner',
  'spiral drill collar',
  'ssv closed',
  'ssv open',
  'stabilizer',
  'subsurface safety valve closed',
  'subsurface safety valve open',
  'sucker rod pump.cutaway',
  'sucker rod pump',
  'sucker rod',
  'tail joint',
  'tail pipe',
  'tool',
  'tricone drill bit',
  'tubing anchor',
  'tubing hanger',
  'tubing.gold',
  'tubing.green',
  'tubing.grey',
  'tubing.red',
  'tubing',
  'valve closed',
  'valve open',
  'valve',
  'wellhead',
  'wireline guide.2',
  'wireline guide',
  'yblock',
  'extras/crossover.grey',
  'extras/drill bit.1',
  'extras/drill bit.2',
  'extras/drill bit.3',
  'extras/drill bit.4',
  'extras/gas lift mandrel.grey',
  'extras/hole opener.1',
  'extras/hole opener.2',
  'extras/hole opener.3',
  'extras/reamer.1',
  'extras/reamer.2',
  'extras/reamer.3',
  'extras/tricone drill bit.grey',
  'deprecated/cement_w_gradient',
  'deprecated/drill bit.2',
  'deprecated/drill bit.3',
  'deprecated/float collar',
  'deprecated/hollowareafill',
  'deprecated/jet pump.ORIGINAL',
  'deprecated/liner slotted',
  'deprecated/liner',
  'deprecated/mule shoe.2',
  'deprecated/mule shoe',
  'deprecated/old_perf',
  'deprecated/perforation',
  'deprecated/pump barrel.ORIGINAL',
  'deprecated/rod pump',
  'deprecated/sliding sleeve.2.ORIGINAL',
  'deprecated/spiral drill collar',
  'deprecated/sq',
  'deprecated/ssv closed',
  'deprecated/ssv open',
  'deprecated/tricone drill bit.old',
  'deprecated/tub_valid',
  'animated/drill bit',
  'animated/spiral drill collar',
];

const getGeometryProperty = (geometry, propertyName) => {
  if (Array.isArray(geometry)) {
    geometry = geometry[0];
  }
  return geometry[propertyName];
};

// const registerSchematicComponents = (data) => {
//   const components = wellBoreNodeLatestData.map((component) => {
//     const { name, data: componentData } = component;
//     const { depth, diameter } = componentData.geometry;
//     const { from, to } = depth;
//     const { outer, inner } = diameter;

//     data.addComponent(name, {
//       geometry: {
//         depth: { from, to },
//         diameter: { outer, inner },
//       },
//     });
//     return JSON.parse(
//       JSON.stringify(data.getProperties()['elements'].slice(-1)[0]),
//     );
//   });
//   return components;
// };

const highlightComponentNode = (
  componentNode,
  wellBoreNode,
  highlightLayer,
) => {
  if (componentNode === undefined) {
    return;
  }
  let bounds = componentNode.getBounds();
  const diameters = getGeometryProperty(
    componentNode.getData()['geometry'],
    'diameter',
  );

  if (diameters['inner'] === undefined) {
    bounds = wellBoreNode.getSceneTransform().transform(bounds);
    bounds = highlightLayer.getSceneTransform().inverseTransform(bounds);
    leftRectangle.setBounds(bounds);
    leftRectangle.setVisible(true);
  } else {
    const width = (diameters['outer'] - diameters['inner']) / 2;
    let leftBounds = new Rect(
      bounds.getLeft(),
      bounds.getTop(),
      bounds.getLeft() + width,
      bounds.getTop() + bounds.getHeight(),
    );
    let rightBounds = new Rect(
      bounds.getRight() - width,
      bounds.getTop(),
      bounds.getRight(),
      bounds.getTop() + bounds.getHeight(),
    );
    leftBounds = wellBoreNode.getSceneTransform().transform(leftBounds);
    leftBounds = highlightLayer
      .getSceneTransform()
      .inverseTransform(leftBounds);
    rightBounds = wellBoreNode.getSceneTransform().transform(rightBounds);
    rightBounds = highlightLayer
      .getSceneTransform()
      .inverseTransform(rightBounds);
    leftRectangle.setBounds(leftBounds);
    rightRectangle.setBounds(rightBounds);
    leftRectangle.setVisible(true);
    rightRectangle.setVisible(true);
  }
};

const createWellLogWidget = function (wellBoreNode, geometryBounds) {
  const widget = new WellLogWidget({
    header: { visible: false },
    footer: { visible: false },
    border: { visible: false },
    horizontalscrollable: false,
    verticalscrollable: false,
    nodefilter: (node) =>
      node instanceof LogAbstractVisual || node instanceof WellBoreNode,
    tools: {
      cursortracking: {
        tooltip: {
          enabled: true,
        },
      },
    },
  }).setDepthLimits(geometryBounds.getTop(), geometryBounds.getBottom());
  widget
    .addTrack(TrackType.AnnotationTrack)
    .setWidth(400)
    .addChild([wellBoreNode]);
  return widget;
};

// const createSchematicRegistry = function () {
//   return new ComponentNodeFactoryRegistry(false)
//     .setFactory('tubing', (data) => new NodeTubingBW(data))
//     .setFactory('packer', (data) => new NodePackerBW(data))
//     .setFactory('cement', (data) => new NodeCementBW(data))
//     .setFactory('perforation', (data) => new NodePerforationBW(data))
//     .setFactory('casing', (data) => new NodeCasingBW(data));
// };

// const createWellBoreData = () => {
//   return new WellBoreData(wellBoreData);
// };

// const createSchematicTable = (components) => {
//   const rows = [];
//   components.forEach((component) => {
//     const geom = component['data']['geometry'];
//     rows.push([
//       component.name,
//       ComponentUtils.getDepthFrom(geom),
//       ComponentUtils.getDepthTo(geom),
//       ComponentUtils.getOuterDiameter(geom),
//       ComponentUtils.getInnerDiameter(geom) || 0,
//     ]);
//   });
//   const dataTable = new DataTable({
//     cols: [
//       { name: 'Type', type: 'string' },
//       { name: 'Depth (from)', type: 'number' },
//       { name: 'Depth (to)', type: 'number' },
//       { name: 'Outer Radius', type: 'number' },
//       { name: 'Inner Radius', type: 'number' },
//     ],
//     rowsdata: rows,
//   });
//   const bridge = new DataTableAdapter({
//     datatable: dataTable,
//   });

//   return new TableView({
//     horizontalscroll: 'floating',
//     verticalscroll: 'floating',
//     cols: 4,
//     defaultcellsize: new Dimension(80, 30),
//     highlightcolumnfillstyle: FillStyle.Empty,
//   }).setData(bridge);
// };

const options = {
  data: new WellBoreData(wellBoreNodeLatestData),
  wellborenode: {
    viewmode: ViewMode.Compressed,
    trackwidth: 200,
  },
  legend: {
    offset: { x: -10, y: 10 },
    width: 250,
    height: 300,
    visible: true,
  },
  gap: {
    horizontal: {
      left: 10,
    },
  },
  // north: { title: { text: 'Schematic 2D Well Bore' } },
  // gap: {
  //   top: {
  //     visible: false,
  //     resizable: false,
  //     size: '0',
  //   },
  //   left: {
  //     visible: true,
  //     resizable: false,
  //     size: '30px',
  //   },
  //   right: {
  //     visible: true,
  //     resizable: false,
  //     size: '30px',
  //   },
  //   bottom: {
  //     visible: false,
  //     resizable: false,
  //     size: '0',
  //   },
  // },
  // annotationssizes: {
  //   south: 0,
  //   west: 0
  // },
  // data: {
  //   elements: createWellBoreData()
  // },
  // tools: {
  //   rubberbandzoom: {
  //     mode: 'Free',
  //     linestyle: 'red',
  //   },
  // },
  east: [],
  west: [],
  south: [],
  // center: {axis:{visible:false}, transformations: {dx: 0,
  //   dy: 0,
  //   xx: 0,
  //   xy: 0,
  //   yx: 0,
  //   yy: 0,}},
  // none: [],
  // northeast: [],
  southwest: [],
  northwest: [],
  // border: null,
  // annotationitemswrap:false,
  // animationstyle: null,
  // clipping: false,
  // overlays: []
};

const WellBoreSchematic = ({ classes }) => {
  const [dataState, setDataState] = useState(null);
  const [isOpen, setIsOpen] = useState(false);
  const canvasRef = useRef();
  const schematicWidgetRef = useRef();
  const wellBoreNodeRef = useRef();
  const higlightRef = useRef();
  // const classes = useStyles();

  const schematicWidget = new CompositeSchematicsWidget(options);
  schematicWidgetRef.current = schematicWidget;

  // const handleClick = (index) => {
  //   if (wellBoreNodeRef.current && higlightRef.current) {
  //     leftRectangle.setVisible(false);
  //     rightRectangle.setVisible(false);
  //     const componentNode = wellBoreNodeRef.current.getComponents().toArray()[
  //       index
  //     ];
  //     highlightComponentNode(
  //       componentNode,
  //       wellBoreNodeRef.current,
  //       higlightRef.current,
  //     );
  //   }
  // };

  useEffect(() => {
    Agent.get('/wellbore/5446/schematic').then((data) => {
      function compareNumbers(a, b) {
        return (
          a.data.geometry.depth.from.value - b.data.geometry.depth.from.value
        );
      }
      const [_first, ...rest] = data.components;
      setDataState(rest.sort(compareNumbers));
    });
  }, []);

  useEffect(() => {
    if (canvasRef.current && dataState != null) {
      // const wellBoreNode = new WellBoreNode({
      //   data: new WellBoreData(wellBoreNodeLatestData),
      // });
      const mappedData = dataState.map(({ name, data }) => {
        const { description, geometry } = data;
        const { depth, diameter } = geometry;
        return {
          name,
          data: {
            description,
            geometry: {
              depth: {
                from: depth.from.value,
                to: depth.to.value,
              },
              diameter: {
                outer: diameter.outer.value,
                inner: diameter.inner.value,
              },
            },
          },
        };
      });

      const registry = new ComponentNodeFactoryRegistry(true);
      const wellBoreData = new WellBoreData([
        ...mappedData,
        // dataState[1],
        // {
        //   name: 'tubing',
        //   data: {
        //     description: 'Head',
        //     geometry: {
        //       depth: {
        //         from: -10,
        //         to: 1000,
        //       },
        //       diameter: {
        //         outer: 8,
        //         inner: 0,
        //       },
        //     },
        //   },
        // },
        // {
        //   name: 'crossover',
        //   data: {
        //     description: 'Crossover',
        //     geometry: {
        //       depth: {
        //         from: 0,
        //         to: 50,
        //       },
        //       diameter: {
        //         outer: 8,
        //         inner: 0,
        //       },
        //     },
        //   },
        // },
      ]);
      // const wellBoreData = new WellBoreData(wellBoreNodeLatestData);
      // const components = wellBoreData.getProperties()['elements'];
      const geometryBounds = wellBoreData.getGeometryBounds();
      const wellBoreNode = new WellBoreNode({
        data: wellBoreData,
        viewmode: ViewMode.Compressed,
        registry,
      }).setBounds(
        new Rect(0.2, geometryBounds.getTop(), 0.8, geometryBounds.getBottom()),
      );

      wellBoreNodeRef.current = wellBoreNode;
      const wellLogWidget = createWellLogWidget(wellBoreNode, geometryBounds);
      // const plot = new Plot({
      //   canvaselement: canvasRef.current,
      //   root: schematicWidget,
      // });
      // const schematicComponents = schematicWidget.getData().getProperties()[
      //   'elements'
      // ];
      // const schematicTable = createSchematicTable(components);
      const group = new Group({ automodellimitsmode: false })
        .setLayout(new CssLayout())
        .addChild(
          wellLogWidget.setLayoutStyle({
            top: 0,
            left: 0,
            bottom: 0,
            width: 400,
          }),
          // wellBoreNode.setLayoutStyle({
          //   top: 0,
          //   right: 0,
          //   bottom: '50%',
          //   width: 700,
          // }),
        );
      const plot = new Plot({
        canvaselement: canvasRef.current,
        root: group,
      });

      wellBoreNode.setProperties({ border: null });
      // wellBoreNode.setFillStyle(new FillStyle('yellow'));
      wellBoreNode.setProperties({
        linestyle: { color: 'transparent', width: 0 },
      });
      wellLogWidget.fitToHeight();
      wellLogWidget.setProperties({ border: { visible: false } });
      // wellLogWidget.setFillStyle(new FillStyle('green'));
      wellLogWidget.setProperties({
        linestyle: { color: 'transparent', width: 0 },
      });
      group.setProperties({ border: null });
      // group.setFillStyle(new FillStyle('red'));
      group.setProperties({
        linestyle: { color: '#303030', width: 2 },
      });

      // const wellBoreNode = from(schematicWidget.getModel()).where((node) => {
      //   return node instanceof WellBoreNode;
      // });
      // Create highlighting layer
      const highlight = new Layer();
      higlightRef.current = highlight;

      const highlightLineStyle = new LineStyle('transparent');
      const highlightFillStyle = new FillStyle('rgba(255, 255, 255, 0.36)');
      leftRectangle = new Rectangle({
        linestyle: highlightLineStyle,
        fillstyle: highlightFillStyle,
        visible: false,
      });
      rightRectangle = new Rectangle({
        linestyle: highlightLineStyle,
        fillstyle: highlightFillStyle,
        visible: false,
      });
      highlight.addChild([leftRectangle, rightRectangle]);
      wellLogWidget.getTrackContainer().addLayer(highlight);

      const selectionOff = () => {
        // Remove table row highlight:
        // schematicTable.setActiveRow(null);

        // Remove schematics node highlight:
        leftRectangle.setVisible(false);
        rightRectangle.setVisible(false);
      };

      // Add table listener:
      // schematicTable
      //   .getToolByName('TableViewSelection')
      //   .on(SelectionEvents.onPick, () => {
      //     leftRectangle.setVisible(false);
      //     rightRectangle.setVisible(false);

      //     const index = schematicTable.getActiveRows()[0];
      //     const componentNode = wellBoreNode.getComponents().toArray()[index];
      //     highlightComponentNode(componentNode, wellBoreNode, highlight);
      //   });

      wellLogWidget
        .getToolByName('pick')
        .setNodeFilter((nodes) =>
          nodes.filter((node) => node instanceof ComponentNode),
        )
        // Add wellbore node click listener:
        .on(SelectionEvents.onPick, (evt, sender, eventArgs) => {
          selectionOff();

          // New selection / highlight:
          const nodes = eventArgs.getSelection();
          if (nodes && nodes.length > 0) {
            const componentNode = nodes[nodes.length - 1];
            // Highlight schematics node:
            highlightComponentNode(componentNode, wellBoreNode, highlight);
            // Highlight table row:
            // const id = componentNode.getId();
            // let index = -1;
            // for (let i = 0; i < components.length; ++i) {
            //   if (components[i].data.id === id) {
            //     index = i;
            //     break;
            //   }
            // }
            // schematicTable.setActiveRow(index);
          }
        });

      // const ctx = canvasRef.current.getContext('2d');
      // plot.getRoot().setName('IME');
      // plot
      //   .getCanvas().border= null
      // console.log('PLOT CANVAS', plot.getRoot().getProperties());

      // schematicWidget.getProperties()
      // schematicWidget
      //   .getChildren((node) => node.getCssClasses())
      //   .a.forEach((node,index) => {
      //     node.setCssClass(".NEKIID")
      //     console.log('NAME', node.getProperties());
      //     if (index === 1) {
      //       node.getChildren().a[0].setProperties({fillstyle: 'red',linestyle: "red",visible:false})
      //       // node.setProperties({'border': null})
      //     }
      //     // console.log("NAME", node.getModel())
      //   });
      // console.log(
      //   'WIDGET CSS',
      //   schematicWidget.getChildren((node) => node.getCssClasses()),
      // );

      // const wellBoreWithLabels = from(schematicWidget.getModel())
      //   .where((node) => {
      //     return node instanceof WellBoreWithLabels;
      //   })
      //   .selectFirst();
      // wellBoreWithLabels.setProperties({
      //     'labeling': {
      //         'labelshape': new SymbolLabelShape({'painter': CirclePainter})
      //     }
      // });
      // const css = `.Grid {
      //   htg-major-tickvisible: false;
      //   vtg-major-tickvisible: false;
      //   htg-minor-tickvisible: false;
      //   vtg-minor-tickvisible: false;
      //  }`;
      // schematicWidget.setCss(new CssStyle({ css: css }));
      // schematicWidget.setProperties({ border: null });
      // schematicWidget.setFillStyle(new FillStyle('#303030'));
      // schematicWidget.setProperties({
      //   linestyle: { color: 'transparent', width: 0 },
      // });
      // wellLogWidget.setProperties({
      //   border: {
      //     visible: false,
      //     borders: { left: false, right: false, bottom: false, top: false },
      //     color: 'red',
      //   },
      //   track: {
      //     border: {
      //       visible: false,
      //     },
      //   },
      // });
      // console.log(
      //   'SCHEMATIC WIDGET PROPERTIES',
      //   wellLogWidget.getProperties(),
      //   wellBoreNode.getProperties(),
      //   schematicWidget.getData().getProperties()['elements'],
      //   schematicWidget.getSelectedComponentNodes(),
      //   from(schematicWidget.getModel()).where((node) => {
      //     return node instanceof WellBoreWithLabels;
      //   }),
      //   from(schematicWidget.getModel()).where((node) => {
      //     return node instanceof WellBoreNode;
      //   }),
      // );
      return () => {
        plot.dispose();
      };
    }
  }, [dataState]);

  return (
    <BasePage>
      <main>
        {/* <div style={{ alignItems: 'flex-start', width: '900px' }}> */}
        {/* <button
          type="button"
          onClick={() => {
            schematicWidgetRef.current.zoomIn();
            handleClick();
          }}
        >
          Zoom
        </button>
        <button
          type="button"
          onClick={() => {
            schematicWidgetRef.current.fitToBounds();
          }}
        >
          Zoom to fit
        </button> */}
        {/* </div> */}
        {/* <button type="button" >
          Open
        </button> */}
        <canvas
          ref={canvasRef}
          width="398px"
          height="700px"
          style={{ border: 'none' }}
        />
        <div className={classes.wrapper}>
          <Button
            className={classes.button}
            size="small"
            color="primary"
            variant="contained"
            title="Add component"
            onClick={() => setIsOpen(true)}
          >
            <AddIcon />
            Add
          </Button>
          {/* <SimpleTable onRowClick={handleClick} data={dataState} /> */}
        </div>
        <SchematicDrawer isOpen={isOpen} onClose={() => setIsOpen(false)}>
          <Formik
            enableReinitialize
            onSubmit={(values) => {
              const a = {
                name: values.component,
                description: values.description,
                depthFrom: {
                  value: values.startDepth,
                  unit: 'm',
                },
                depthTo: {
                  value: values.endDepth,
                  unit: 'm',
                },
                outerDiameter: {
                  value: values.outerDiameter,
                  unit: 'm',
                },
                innerDiameter: {
                  value: values.innerDiameter,
                  unit: 'm',
                },
              };
              Agent.post('/wellbore/5446/schematic/1/component/create', a).then(
                () => {
                  setIsOpen(false);
                  Agent.get('/wellbore/5446/schematic').then((data) => {
                    const [_first, ...rest] = data.components;
                    setDataState(rest);
                  });
                },
              );
            }}
            initialValues={{}}
          >
            {() => {
              return (
                <Form id="1">
                  <SelectTextFieldFormik
                    required
                    label="Component"
                    margin="none"
                    items={fromJS(items)}
                    name={'component'}
                    getItemValue={(componentName) => componentName}
                    getItemName={(componentName) => componentName}
                  />
                  <Field
                    // className={classes.textArea}
                    // required
                    // label="Description"
                    // name="description"
                    // component={TextAreaFieldFormik}
                    // margin="dense"
                    name={'description'}
                    label="Description"
                    type="text"
                    component={TextFieldFormik}
                    fullWidth
                    variant="outlined"
                  />
                  {/* <TextAreaField
                    label="Description"
                    input={{ defaultValue: '', name: 'description' }}
                    onChange={(e) => console.log(e.target.value)}
                  /> */}
                  <div className={classes.fieldWrapper}>
                    <Field
                      className={classes.field}
                      required
                      type="number"
                      label="Start Depth"
                      name="startDepth"
                      component={TextFieldFormik}
                      // onChange={(e) => console.log(e.target.value)}
                    />
                    {/* <TextField
                      className={classes.field}
                      required
                      type="number"
                      // onChange={(e) => console.log(e.target.value)}
                      // value={localWeight}
                      // inputProps={{
                      //   step: '0.01'
                      // }}
                      label="Start Depth"
                      input={{ defaultValue: '', name: 'startDepth' }}
                    /> */}
                    <Field
                      className={classes.field}
                      required
                      type="number"
                      label="End Depth"
                      destroyOnUnmount
                      name="endDepth"
                      // onChange={(e) => console.log(e.target.value)}
                      component={TextFieldFormik}
                    />
                    {/* <TextField
                      className={classes.field}
                      required
                      type="number"
                      // onChange={(e) => console.log(e.target.value)}
                      label="End Depth"
                      input={{ defaultValue: '', name: 'endDepth' }}
                    /> */}
                  </div>
                  <div className={classes.fieldWrapper}>
                    <Field
                      className={classes.field}
                      required
                      type="number"
                      label="Inner Diameter"
                      name="innerDiameter"
                      // onChange={(e) => console.log(e.target.value)}
                      component={TextFieldFormik}
                    />
                    {/* <TextField
                      className={classes.field}
                      required
                      type="number"
                      // onChange={(e) => console.log(e.target.value)}
                      label="Inner Diameter"
                      input={{ defaultValue: '', name: 'innerDiameter' }}
                    /> */}
                    <Field
                      className={classes.field}
                      required
                      type="number"
                      label="Outer Diameter"
                      name="outerDiameter"
                      // onChange={(e) => console.log(e.target.value)}
                      component={TextFieldFormik}
                    />
                    {/* <TextField
                      className={classes.field}
                      required
                      type="number"
                      // onChange={(e) => console.log(e.target.value)}
                      label="Outer Diameter"
                      input={{ defaultValue: '', name: 'outerDiameter' }}
                    /> */}
                  </div>
                  {/* <button
                    type="submit"
                    disabled={isSubmitting || !isValid || !dirty}
                  >
                    AAAAAA
                  </button> */}
                </Form>
              );
            }}
          </Formik>
        </SchematicDrawer>
      </main>
    </BasePage>
  );
};

const styles = () => ({
  fieldWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  field: {
    width: '48%',
  },
  textArea: {
    backgroundColor: '#303030',
  },
  button: {
    marginBottom: '10px',
    alignSelf: 'flex-end',
  },
  wrapper: {
    display: 'flex',
    flexDirection: 'column',
  },
});

export default withStyles(styles)(WellBoreSchematic);
